#import "../../../../common/graphql/ExtractionTypes.graphql"
query PaymentAvailableDocumentTypes($transactionTypeId: Int!) {
  paymentAvailableDocumentTypes(transactionTypeId: $transactionTypeId) {
    nodes {
      id
      documentType
      isAccountingDocument
      ...ExtractionTypes
    }
  }
}
